<template>
  <router-view></router-view>
</template>

<script>
import animate from "animate.css";
export default {};
</script>

<style>
* {
  padding: 0;
  margin: 0; 
}
/* 全浏览器兼容基础样式 */
:root {
  --primary-color: #2c3e50;
  --placeholder-color: #afbdcc;
}

#app {
  /* 多行字体兼容写法 */
  font-family: system-ui, -apple-system, "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
    sans-serif;

  /* 字体平滑处理 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegacy; /* IE */

  color: var(--primary-color);
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;

  /* 修复IE滚动条 */
  overflow: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

/* 增强型全局重置 */
html {
  /* 防止iOS字体缩放 */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  /* 触控优化 */
  touch-action: manipulation;
  /* 弹性滚动 */
  -webkit-overflow-scrolling: touch;
}

body {
  /* 旧版Android字体抗锯齿 */
  text-shadow: 0 0 1px transparent;
  /* 强制GPU渲染 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

/* 全平台滚动条处理 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: rgba(245, 245, 245, 0.8);
}
::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

/* Firefox滚动条 */
* {
  scrollbar-width: thin;
  scrollbar-color: #cccccc rgba(245, 245, 245, 0.8);
}

/* IE滚动条颜色 */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  body {
    scrollbar-base-color: #cccccc;
    scrollbar-face-color: #cccccc;
  }
}

/* 增强型输入框重置 */
input,
textarea,
button {
  /* 全平台清除默认样式 */

  /* 禁用怪异模式 */
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;

  /* 输入法优化 */
  ime-mode: active;
}

/* 自动填充颜色统一 */
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
  -webkit-text-fill-color: var(--primary-color);
}

/* 全平台placeholder */
::placeholder {
  color: var(--placeholder-color);
  opacity: 1;
}
:-ms-input-placeholder {
  color: var(--placeholder-color);
}
::-ms-input-placeholder {
  color: var(--placeholder-color);
}

/* 现代flex布局系统 */
.b {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

/* 旧版flex兼容处理 */
.flex {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

/* 方向兼容 */
.tb {
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
}

/* 对齐方式兼容 */
.pc {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ac {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/* 动画兼容处理 */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  -webkit-animation: fadeIn 0.3s;
  -moz-animation: fadeIn 0.3s;
  animation: fadeIn 0.3s;
}

/* 图片兼容处理 */
img {
  display: inline-block;
  max-width: 100%;
  height: auto;
  /* 抗锯齿处理 */
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  /* IE滤镜 */
  -ms-interpolation-mode: nearest-neighbor;
}

/* 伪元素加载失败提示 */
img::after {
  content: "Image not found";
  display: block;
  font-size: 12px;
  color: #999;
  background: #eee;
  padding: 2px 5px;
}

/* 移动端优化 */
@media (hover: none) {
  a,
  button {
    /* 消除点击延迟 */
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /* 长按菜单禁用 */
    -webkit-touch-callout: none;
  }
}

/* IE11专用hack */
_:-ms-fullscreen,
:root .ie11-hack {
  /* IE11特定样式 */
}

/* 打印样式优化 */
@media print {
  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
* {
  scrollbar-width: none;
}
/* 新增手机端滚动条隐藏样式 */
@media (max-width: 768px) {
  /* WebKit内核浏览器（Chrome/Safari/Edge） */
  ::-webkit-scrollbar {
    width: 0 ;
    height: 0 ;
  }

  /* Firefox浏览器 */
  * {
    scrollbar-width: none ; /* 隐藏滚动条 */
    -ms-overflow-style: none ; /* IE/Edge */
  }

  /* 修复弹性滚动兼容性 */
  html {
    -webkit-overflow-scrolling: touch ;
  }

}
.el-message-box {
  position: fixed !important;
  top: 40vh !important; /* 居中关键：顶部对齐视口50%位置 */
  left: 50% !important;
  transform: translate(-50%, -50%) !important; /* 同时向左和向上移动自身尺寸的50% */
}
@media (max-width: 768px) {
  .el-message-box{
    top: 45vh!important;
    zoom: 0.8!important;
  }

}
@media (max-width: 1200px) {

  .el-button+.el-button {
  margin-left: 0px !important;
}
}



/* Safari对话框层级修复 */
/* .safari-dialog-fix {
  z-index: 3000 !important; 
} */

/* 确保遮罩层也有更高的z-index */
/* .el-dialog__wrapper {
  z-index: 2999 !important;
}

.v-modal {
  z-index: 2998 !important;
} */

</style>